import React, { useContext, type PropsWithChildren } from "react"
import GlobalStyles from "./GlobalStyles"
import { theme } from "./theme"
import { ThemeProvider } from "styled-components"
import "@fontsource/inter"
import "@fontsource/inter/500.css"
import "@fontsource/inter/700.css"
import "@fontsource/manrope"
import "@fontsource/manrope/700.css"
import "@fontsource/lora"
import "@fontsource/lora/500.css"
import "@autouncle/ui/dist/tokens.css"
import uiStyles from "@autouncle/ui/dist/styles.css?raw"
import LibUIThemeProvider from "component_library/components/react/LibUIThemeProvider"
import { useInitI18n } from "lib/hooks/useInitI18n"
import { Spinner } from "@autouncle/ui"
import LocaleContext from "component_library/contexts/localeContext"

const Template = ({ children }: PropsWithChildren) => {
  const locale = useContext(LocaleContext)
  const isI18nLoading = useInitI18n(locale || "en")

  return (
    <>
      {/* eslint-disable @typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore */}
      <GlobalStyles />
      <style type="text/css" dangerouslySetInnerHTML={{ __html: uiStyles }} />
      <LibUIThemeProvider>
        <ThemeProvider theme={theme}>
          {isI18nLoading ? <Spinner text="loading..." /> : children}
        </ThemeProvider>
      </LibUIThemeProvider>
    </>
  )
}

export default Template
